import { IconProps } from "../../utils/global-types/global-types";

const TasksIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_8725_90596)">
        <path
          fill="currentColor"
          d="M13.9 3.4h-2.93A2.09 2.09 0 0 0 9 2c-.913 0-1.683.588-1.97 1.4H4.1a1.4 1.4 0 0 0-1.4 1.4v9.8A1.4 1.4 0 0 0 4.1 16h9.8a1.4 1.4 0 0 0 1.4-1.4V4.8a1.4 1.4 0 0 0-1.4-1.4M9 3.4a.7.7 0 1 1 0 1.4.7.7 0 0 1 0-1.4m-1.4 9.8-2.8-2.8.99-.99 1.81 1.809 4.61-4.61.99.991z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_8725_90596">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default TasksIcon;
